export const JWT_USER_TOKEN = 'dr_kovalenko_jwt_user';
